import type { MultiSelectOption } from '@rtkwlf/fenrir-react';
import type { QueryParamConfig } from 'use-query-params';

import { LabelLookupMultiSelectOptionParam } from '../label-lookup-multi-select-option-param/label-lookup-multi-select-option-param';

export const MultiSelectOptionParam: QueryParamConfig<
  MultiSelectOption[] | undefined
> = LabelLookupMultiSelectOptionParam();
